import { render, staticRenderFns } from "./MessageComposer.vue?vue&type=template&id=e977c97c&scoped=true&"
import script from "./MessageComposer.vue?vue&type=script&lang=js&"
export * from "./MessageComposer.vue?vue&type=script&lang=js&"
import style0 from "./MessageComposer.vue?vue&type=style&index=0&id=e977c97c&lang=scss&scoped=true&"
import style1 from "./MessageComposer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e977c97c",
  null
  
)

export default component.exports